export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_13.83ccc6e5.jpg";